import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';
import { Share } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';

const config = {
    items: ['sina', 'wechat', 'cof', 'qqzone'],
    display: 'normal',
    hover: 'hover',
    type: 'vertical',
    methods: 'hover',
    tooltip: 'right',
};

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        shareBoxTop: PropTypes.number,
    };

    state = {
        isShareShow: true,
        isToTopShow: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        const { shareBoxTop } = this.props;
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (currentTop > 100) {
            this.setState({ isToTopShow: true });
        } else {
            this.setState({ isToTopShow: false });
        }

        if (currentTop >= shareBoxTop - 200) {
            this.setState({ isShareShow: false });
        } else {
            this.setState({ isShareShow: true });
        }
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShareShow, isToTopShow } = this.state;
        const {
            content: { title, summery, imagesInContent, commentUrl },
        } = this.props;
        const shareInfo = {
            url: commentUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const affix = (
            <React.Fragment>
                <div className={styles.bottom_affix}>
                    {isShareShow ? <Share config={config} shareInfo={shareInfo} /> : ''}
                </div>
                <div className={styles.toTop_affix}>
                    {isToTopShow ? <span className={styles.backToTop} onClick={this.backToTop} /> : ''}
                </div>
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
